import { DetailItem } from "@/Shared";
import { MediaFileModel } from "./MediaFileModel";
import { AuditViewModel } from "@/Shared/Logic/ViewModels/AuditViewModel";

export class MediaFileViewModel {
    public id? : number;
    public fileName: string;
    public diskName: string;
    public originalName: string;
    public filePath: string;
    public mimeType: string;
    public fileSize: number;
    public fileType: string;
    public folderPath: string;


    constructor(
        private media?: MediaFileModel,
        private audit? : AuditViewModel
    ) {
        this.id = media?.id;

        this.fileName = media?.fileName ?? "";
        this.diskName = media?.diskName ?? "";
        this.originalName = media?.originalName ?? "";
        this.filePath = media?.filePath ?? "";
        this.mimeType = media?.mimeType ?? "";
        this.fileSize = media?.fileSize ?? 0;
        this.fileType = media?.fileType ?? "";
        this.folderPath = media?.folderPath ?? "";

    }

    getFileSection = (): DetailItem[] => {
		return [
			{ label: "N° Fichier", value: String(this.id) },
			{ label: "Nom Original", value: this.originalName },
			{ label: "Nom Interne", value: this.fileName },
			{ label: "Type MIME", value: this.mimeType },
			{ label: "Taille (octets)", value: String(this.fileSize) },
			{ label: "Chemin", value: this.filePath },
			{ label: "Dossier", value: this.folderPath },
			{ label: "Créé le", value: this.audit?.creationDate ?? "" },
			{ label: "Créé par", value: this.audit?.creatorName ?? "" },
		];
	};

}